// extracted by mini-css-extract-plugin
export var animationContainer = "_ff-0";
export var asteriskIcon = "_ff-8";
export var conversationLeftSection = "_ff-4";
export var conversationListItem = "_ff-3";
export var conversationMiddleSection = "_ff-5";
export var conversationRightSection = "_ff-6";
export var detailsContent = "_ff-1";
export var listContainer = "_ff-7";
export var modalContent = "_ff-2";